<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :hideHeader="false"
        :autoheight="false"
        :multiselect="false"
        :pageable="false"
        :showCountControl="false"
        :showDisplayCountControl="false"
        :initial-pagesize="1"
        :pagesizeoptions="[1]"
      />
      <div class="mrB30" />
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comp_label">{{this.frame0.module}}</div>
            <div class="comp_label"></div><!--submodule-->
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_REF_TRM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comp_label">{{this.frame0.sourceTermName}}</div>
          </div>
          
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CODE_NAME')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comp_label">{{this.frame0.codeId}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TRM_DSCR')"
              :required="false"
              :vertical="false"
              :disabled="true"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{this.frame0.termDesc}}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TRM_EN_DSCR')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{this.frame0.termsEnglishName}}
            </div>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_APPL_CNTN')" :required="true" :vertical="false" />
          </div>
          <div class="col-xs-11">
            <textarea ></textarea>
          </div>
        </div> -->
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onCancel"
      >
        {{$t('MSG_BTN_CLOSE')}}
      </sui-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMT_00004_P02',
  props: {
    parentPageId: String,
    biddingInformationParam: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      frame0: {
        termName: '',
        termPhyName: '',
        termDesc: '',
        domainName: '',
        rangeDate: { start: '', end: '' },
        sourceTermName: '',
        domainDataTypeCode: '',
        firstRegisterUserId: '',
        module:'',
        codeId:'',
        applicantID:'',
        termsApplicationContent:'',
        termsEnglishName:''
      },
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_WRD_NM'),
        datafield: 'termsName',
      }, {
        text: this.$t('MSG_TXT_TRM_PHSC_NM'),
        datafield: 'termsId',
      }, {
        text: this.$t('MSG_TXT_DOMAIN_NAME'),
        datafield: 'domainName',
      }, {
        text: this.$t('MSG_TXT_DOM_PHSC_NM'),
        datafield: 'domainPhysicalName',
      }, {
        text: this.$t('MSG_TXT_DT_TYP'),
        datafield: 'domainDataTypeName',
      }, {
        text: this.$t('MSG_TXT_LEN'),
        datafield: 'domainLength',
      }, {
        text: this.$t('MSG_TXT_DECM_LGHT'),
        datafield: 'domainDataDecimalLength',
      }, {
        text: this.$t('MSG_BTN_DPCT_CHK'),
        datafield: 'duplicationCheck',
      }],
    };
  },
  computed: {
    // retrieve data in popup

  },
  watch: {},
  mounted() {
    console.log (this.biddingInformationParam);
    this.frame0.sourceTermName = this.biddingInformationParam.sourceTerm;
    this.frame0.domainDataTypeCode = this.biddingInformationParam.domainDataTypeCode;
    this.frame0.domainName = this.biddingInformationParam.domainName;
    this.frame0.firstRegisterUserId = this.biddingInformationParam.firstRegistrationUserId;

    if(this.biddingInformationParam.moduleName)
    {
      this.frame0.module = this.biddingInformationParam.moduleName + '  ' + this.biddingInformationParam.subModuleName;
    }
    this.frame0.termDesc = this.biddingInformationParam.termsContent;
    this.frame0.codeSturctureTypeCode = this.biddingInformationParam.codeValidValue;
    if(this.biddingInformationParam.codeId)
    {
      this.frame0.codeId = this.biddingInformationParam.codeId + '  ' + this.biddingInformationParam.codeValidValue;
    }
    this.frame0.applicantID = this.biddingInformationParam.applicantID;
    this.frame0.termsApplicationContent = this.biddingInformationParam.termsApplicationContent;
    this.frame0.termsEnglishName = this.biddingInformationParam.termsEnglishName;

    let termsName =  this.biddingInformationParam.termsName;
    let termsId = this.biddingInformationParam.termsId;
    let domainName = this.biddingInformationParam.domainName;
    let domainPhysicalName = this.biddingInformationParam.domainPhysicalName;
    let domainDataTypeName = this.biddingInformationParam.domainDataTypeName;
    let domainLength = this.biddingInformationParam.domainLength;
    let domainDataDecimalLength = this.biddingInformationParam.domainDataDecimalLength;
    let duplicationCheck = this.biddingInformationParam.duplicationCheck;
    const data = [{
          'termsName' : termsName,
          'termsId' : termsId,
          'domainName' : domainName,
          'domainPhysicalName' : domainPhysicalName,
          'domainDataTypeName' : domainDataTypeName,
          'domainLength' : domainLength,
          'domainDataDecimalLength': domainDataDecimalLength,
          'duplicationCheck': duplicationCheck
        }];
        this.dataset0.setRawData(data);
  },
  beforeUpdate() {
  },
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onCancel() {
      this.$emit('exit', true);
    },
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'termsName',
      type: 'string',
      map: 'termsName',
    }, {
      name: 'termsId',
      type: 'string',
      map: 'termsId',
    }, {
      name: 'domainName',
      type: 'string',
      map: 'domainName',
    }, {
      name: 'domainPhysicalName',
      type: 'string',
      map: 'domainPhysicalName',
    }, {
      name: 'domainDataTypeName',
      type: 'string',
      map: 'domainDataTypeName',
    }, {
      name: 'domainLength',
      type: 'string',
      map: 'domainLength',
    }, {
      name: 'domainDataDecimalLength',
      type: 'string',
      map: 'domainDataDecimalLength',
    }, {
      name: 'duplicationCheck',
      type: 'string',
      map: 'duplicationCheck',
    }],
  }],
};
</script>
<style scoped>
</style>
